
document.addEventListener('change', function (e) {

  if (!e.target.matches('input[name="properties[Diamond Type]"]')) return;

  const wrapper = e.target.closest('[data-diamond-options]');
  if (!wrapper) return;

  const caratWrapper = wrapper.querySelector('[data-carat-wrapper]');
  const naturalInfo = wrapper.querySelector('[data-natural-info]');

  if (e.target.value === 'Lab-Grown') {
    caratWrapper.hidden = false;
    naturalInfo.hidden = true;
  } else {
    caratWrapper.hidden = true;
    naturalInfo.hidden = false;

    wrapper
      .querySelectorAll('input[name="properties[Carat Weight]"]')
      .forEach(i => (i.checked = false));
  }
});
